import { useMemo } from "react";
import { useLocation } from "react-router-dom";

interface KeyObject {
    [key: string]: string;
}

export const useQuery = (): UseQuery => {
    const { search } = useLocation();

    const searchParams = new URLSearchParams(search);

    const allParams: KeyObject = {};

    // remove the leading '?' and split the query string by '&'
    search
        .substring(1)
        .split("&")
        .forEach((param) => {
            const [key, value] = param.split("=");
            if (key && value) {
                allParams[decodeURIComponent(key)] = value;
            }
        });

    return useMemo(
        () => ({
            searchParams,
            allParams
        }),
        [search]
    );
};

interface UseQuery {
    searchParams: URLSearchParams;
    allParams: KeyObject;
}
